import { render } from "./ModalMailFailures.vue?vue&type=template&id=0789affe&scoped=true"
import script from "./ModalMailFailures.vue?vue&type=script&lang=js"
export * from "./ModalMailFailures.vue?vue&type=script&lang=js"

import "./ModalMailFailures.vue?vue&type=style&index=0&id=0789affe&scoped=true&lang=css"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0789affe"]])

export default __exports__